export const readAccessLost=error=>[401,403,404].includes(error?.response?.status);

export function userError(error, fallback = "Toiminto ei onnistunut. Yritä uudelleen.") {
  const status = error?.response?.status;
  if (status === 401) return "Kirjaudu uudelleen. Keskeneräistä pyyntöä ei lähetetä automaattisesti.";
  if (status === 403) return "Sinulla ei ole oikeutta tähän toimintoon.";
  if (status === 402 || status === 429) return "Palvelun käyttöraja on täynnä. Voit käyttää muita toimintoja ja yrittää myöhemmin uudelleen.";
  if (status === 503) return "Palvelu ei ole juuri nyt käytettävissä. Tarkista palveluyhteyksien tila asetuksista.";
  if (status === 504 || error?.code === "ECONNABORTED") return "Palvelu ei vastannut ajoissa. Tarkista tallennuksen tila ennen uudelleenyritystä.";
  if (status >= 500) return "Palvelussa tapahtui virhe. Yritä hetken kuluttua uudelleen.";
  return fallback;
}
